/* eslint eqeqeq: off */
import React from "react";
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import {connect} from "react-redux";
import Hospital from "../../../Server/Hospital";
import PropTypes from "prop-types";
import Input from "../../../Components/Control/Input";
import Group, {GroupHead, GroupTabContent} from "../../../Components/Group";
import * as moment from "jalali-moment";
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import './index.css';
import Label from "../../../Components/Control/Label";
import Check from "../../../Components/Control/Check";
import Time from "../../../Components/Control/Time";
import Resource from "../../../Resource";
import ModalHospitalDeliverProduct from "../ModalHospitalDeliverProduct";
import ModalPrint from "../ModalPrint";
import {printerTemplate} from "../../../Printer";
import {updateBase} from "../../../Redux/Actions/base";
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import Prompt, {PromptControl} from "../../../Components/Prompt";
import ModalPrepareAlert from "../ModalPrepareAlert";
import BarcodeReader from 'react-barcode-reader';
import Product from '../../../Server/Product';
import Perms from '../../../Perms';
import InputButton from '../../../Components/Control/InputButton';
import MyComponent from '../../../Components/MyComponent';
import ModalProductList from "../ModalProductList";

class ModalHospitalReadyProduct extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;

        this.Perms = {
            1: { // Norm
                CROSS_MATCH_OR_SENT: {
                    VIEW: Perms().BLOOD_BANK_NORM_REQUESTS.CROSS_MATCH_OR_SENT.VIEW,
                    CANCEL_CROSS_MATCH: Perms().BLOOD_BANK_NORM_REQUESTS.CROSS_MATCH_OR_SENT.CANCEL_CROSS_MATCH,
                    DELIVERY: Perms().BLOOD_BANK_NORM_REQUESTS.CROSS_MATCH_OR_SENT.DELIVERY,
                    CROSS_MATCH: Perms().BLOOD_BANK_NORM_REQUESTS.CROSS_MATCH_OR_SENT.CROSS_MATCH
                },
                INCOMPATIBLE: {
                    VIEW: Perms().BLOOD_BANK_NORM_REQUESTS.INCOMPATIBLE.VIEW,
                    DELETE: Perms().BLOOD_BANK_NORM_REQUESTS.INCOMPATIBLE,
                    INSERT: Perms().BLOOD_BANK_NORM_REQUESTS.INCOMPATIBLE.INSERT
                }
            },
            2: { // Emer
                CROSS_MATCH_OR_SENT: {
                    VIEW: Perms().BLOOD_BANK_EMER_REQUESTS.CROSS_MATCH_OR_SENT.VIEW,
                    CANCEL_CROSS_MATCH: Perms().BLOOD_BANK_EMER_REQUESTS.CROSS_MATCH_OR_SENT.CANCEL_CROSS_MATCH,
                    DELIVERY: Perms().BLOOD_BANK_EMER_REQUESTS.CROSS_MATCH_OR_SENT.DELIVERY,
                    CROSS_MATCH: Perms().BLOOD_BANK_EMER_REQUESTS.CROSS_MATCH_OR_SENT.CROSS_MATCH
                },
                INCOMPATIBLE: {
                    VIEW: Perms().BLOOD_BANK_EMER_REQUESTS.INCOMPATIBLE.VIEW,
                    DELETE: Perms().BLOOD_BANK_EMER_REQUESTS.INCOMPATIBLE,
                    INSERT: Perms().BLOOD_BANK_EMER_REQUESTS.INCOMPATIBLE.INSERT
                }
            }
        };

        this.state = {
            deliveryGrid: {
                defaultColDef: {
                    floatingFilter: false
                },
                statusBar: false,
                columnDefs: [{
                    field: 'productNumber',
                    headerName: 'شماره فرآورده',
                    headerTooltip: 'شماره فرآورده',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'productTypeStr',
                    headerName: 'نوع فرآورده',
                    headerTooltip: 'نوع فرآورده'
                }, {
                    field: 'productBloodGroupStr',
                    headerName: 'BGRh فرآورده',
                    headerTooltip: 'BGRh فرآورده',
                    cellClass: row => 'green'
                }, {
                    field: 'productExpireDate',
                    headerName: 'زمان انقضا',
                    headerTooltip: 'زمان انقضا',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime.bind(this, 'date')
                }, {
                    field: 'crossMatcherFullName',
                    headerName: 'انجام دهنده',
                    headerTooltip: 'انجام دهنده'
                }, {
                    field: 'createDateTime',
                    headerName: 'زمان آماده سازی',
                    headerTooltip: 'زمان آماده سازی',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime
                }, {
                    field: 'crossMatchStatusStr',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    cellRenderer: 'state',
                    pinned: props.gridDefaultSettings.pinStatusColumn,
                    valueGetter: row => row.data.crossMatchStatusStr
                }, {
                    field: 'crossMatchStatusId',
                    sort: 'asc',
                    comparator: (itemA, itemB) => {
                        const aranjman = [25, 30, 32, 31];
                        const indexA = aranjman.indexOf(itemA);
                        const indexB = aranjman.indexOf(itemB);
                        return indexA - indexB;
                    },
                    hide: true,
                    suppressColumnsToolPanel: true,
                    suppressFiltersToolPanel: true
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 155,
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    state: row => {
                        return <GridStates>
                            {row.data.crossMatchStatusId == 30 && <GridState theme={'green'}>{row.data.crossMatchStatusStr}</GridState>}
                            {row.data.crossMatchStatusId == 25 && <GridState theme={'blue'}>{row.data.crossMatchStatusStr}</GridState>}
                            {row.data.crossMatchStatusId == 31 && <GridState>{row.data.crossMatchStatusStr}</GridState>}
                            {row.data.crossMatchStatusId == 32 && <GridState theme={'yellow'}>{row.data.crossMatchStatusStr}</GridState>}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            {row.data.crossMatchStatusId == 30 && <React.Fragment>
                                <GridButton type={"button"} theme={'print'} title={'چاپ کراسمچ'} onClick={this.printCrossMatch.bind(this, row.data)}/>
                                {this.Perms[this.state.data?.formTypeId]?.CROSS_MATCH_OR_SENT?.CANCEL_CROSS_MATCH && <GridButton type={"button"} theme={'edit'} icon={Resource.IMAGE.PACK.REPLY.BLACK} title={'لغو آماده سازی'} onClick={this.cancelCrossMatch.bind(this, row.data)}/>}
                            </React.Fragment>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node) {
                        return [{
                            name: `ارسال ${this.state.selectedRows.length || ''} فرآورده`,
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EDIT1.BLACK}" alt="">`,
                            action: this.sendProductClickHandler.bind(this),
                            disabled: !(this.state.selectedRows.length && this.Perms[this.state.data?.formTypeId]?.CROSS_MATCH_OR_SENT?.DELIVERY)
                        }, {
                            name: 'لغو آماده سازی',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.REPLY.BLACK}" alt="">`,
                            action: this.cancelCrossMatch.bind(this, params.node.data),
                            disabled: !(params.node.data.crossMatchStatusId == 30 && this.Perms[this.state.data?.formTypeId]?.CROSS_MATCH_OR_SENT?.CANCEL_CROSS_MATCH)
                        }, {
                            name: 'چاپ برچسب آماده سازی',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.PRINTER}" alt="">`,
                            action: this.printCrossMatch.bind(this, params.node.data),
                            disabled: params.node.data.crossMatchStatusId != 30
                        },
                            'separator',
                            ...params.defaultItems];
                    }
                },
                getRowClass: row => row.data.crossMatchStatusId == 31 ? 'gray' : '',
                isRowSelectable: row => row.data.crossMatchStatusId == 30
            },
            incompatibleGrid: {
                defaultColDef: {
                    floatingFilter: false
                },
                statusBar: false,
                columnDefs: [{
                    field: 'productNumber',
                    headerName: 'شماره فرآورده',
                    headerTooltip: 'شماره فرآورده',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'productTypeStr',
                    headerName: 'نوع فرآورده',
                    headerTooltip: 'نوع فرآورده'
                }, {
                    field: 'productBloodGroupStr',
                    headerName: 'BGRh فرآورده',
                    headerTooltip: 'BGRh فرآورده',
                    cellClass: row => 'green'
                }, {
                    field: 'createDateTime',
                    headerName: 'زمان ثبت',
                    headerTooltip: 'زمان ثبت ناسازگاری',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime
                }, {
                    field: 'incompatibleId',
                    sort: 'asc',
                    hide: true,
                    suppressColumnsToolPanel: true,
                    suppressFiltersToolPanel: true
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 155,
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    control: row => {
                        return <GridControls>
                            {this.Perms[this.state.data?.formTypeId]?.INCOMPATIBLE?.DELETE && <GridButton type={"button"} theme={'delete'} icon={Resource.IMAGE.PACK.TRASH1.WHITE} title={'حذف ناسازگاری'} onClick={this.cancelIncompatible.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'حذف ناسازگاری',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.TRASH1.BLACK}" alt="">`,
                            action: this.cancelIncompatible.bind(this, params.node.data),
                            disabled: !this.Perms[this.state.data?.formTypeId]?.INCOMPATIBLE?.DELETE
                        },
                            'separator',
                            ...params.defaultItems];
                },
                getRowClass: row => row.data.crossMatchStatusId == 31 ? 'gray' : '',
                isRowSelectable: row => row.data.crossMatchStatusId == 30
            },
            deliveryGridContext: null,
            incompatibleGridContext: null,
            error: false,
            loading: false,
            printOnPrepare: false,
            updated: false,
            fields: {},
            data: {},
            incompatibleList: [],
            selectedRows: []
        };

        this.ref = {
            deliveryGrid: React.createRef(),
            incompatibleGrid: React.createRef(),
            modal: React.createRef(),
            prompt: React.createRef(),
            modalDeliver: React.createRef(),
            modalPrepareAlert: React.createRef(),
            modalProductList: React.createRef(),
            modalPrint: React.createRef(),
            productNumber: React.createRef(),
            meltingStartDateTime: React.createRef(),
            meltingEndDateTime: React.createRef(),
            prepareProduct: React.createRef(),
            incompatibleProduct: React.createRef(),
            send: React.createRef(),
            close: React.createRef(),
        };
    }

    static defaultProps = {
        refer: null,
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        productNumber: x => Boolean(x) || 'فرآورده ثبت نشده است.'
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state, props} = this;

        return state.error !== nextState.error ||
            state.loading !== nextState.loading ||
            state.data !== nextState.data ||
            state.incompatibleList !== nextState.incompatibleList ||
            state.fields !== nextState.fields ||
            props.base?.hemoReadyProductPrintOnPrepare !== nextProps.base?.hemoReadyProductPrintOnPrepare ||
            state.selectedRows !== nextState.selectedRows;
    }

    render() {
        const {state} = this;
        const tabs = [];

        if (this.Perms[this.state.data?.formTypeId]?.CROSS_MATCH_OR_SENT?.VIEW) {
            tabs.push({id: 'prepared/delivered', title: 'فرآورده‌های آماده / تحویلی', selected: true});
        }
        if (this.Perms[this.state.data?.formTypeId]?.INCOMPATIBLE?.VIEW) {
            tabs.push({id: 'incompatible', title: 'فرآورده‌های ناسازگار'});
        }

        const differentBloodGroup = state.data?.productInfo?.productBloodGroupId &&
            state.data?.patientFileCodeInformation?.patientBloodGroupId &&
            (state.data?.productInfo?.productBloodGroupId !== state.data?.patientFileCodeInformation?.patientBloodGroupId);

        const bloodGroupInputStyle = {};
        if (differentBloodGroup) {
            bloodGroupInputStyle.backgroundColor = 'var(--goo-red)';
            bloodGroupInputStyle.color = 'white';
        }

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalHospitalReadyProduct'}
                   size={'large'}
                   error={state.error}
                   loading={state.loading}
                   style={{minHeight: 'calc(100vh - 60px)'}}
                   title={`آماده سازی و ارسال فرآورده به شماره پرونده: ${state.data?.patientFileCodeInformation?.patientFileCode || ''}`}
                   onClose={this.onModalClose.bind(this)}>
                <ModalContent style={{display: 'flex', flexDirection: 'column'}}>
                    <BarcodeReader
                        onScan={this.barcodeScanHandler.bind(this)}/>
                    <Group className={'mar-b-10'}>
                        <div className="dis-f">
                            <Input className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'شماره پرونده'} value={state.data?.patientFileCode} readOnly={true} align={'center'}/>
                            <Input className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'نام بیمار'} value={state.data?.patientFirstName} readOnly={true}/>
                            <Input className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'نام خانوادگی بیمار'} value={state.data?.patientLastName} readOnly={true}/>
                            <Input className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'گروه خونی'} value={state.data?.patientBloodGroupStr} readOnly={true} align={'center'} direction={'ltr'} style={bloodGroupInputStyle}/>
                        </div>
                    </Group>
                    {(this.Perms[this.state.data?.formTypeId]?.CROSS_MATCH_OR_SENT?.CROSS_MATCH || this.Perms[this.state.data?.formTypeId]?.INCOMPATIBLE?.INSERT) && <Group className={'mar-b-10'}>
                        <GroupHead title={'اطلاعات فرآورده'}>
                            {this.Perms[this.state.data?.formTypeId]?.CROSS_MATCH_OR_SENT?.CROSS_MATCH && <Check className={'pad-h-4'} label={'چاپ خودکار برچسب آماده سازی'} checked={Boolean(this.props.base?.hemoReadyProductPrintOnPrepare)} onChange={this.autoPrintOnPrepareChangeHandler.bind(this)}/>}
                            {this.Perms[this.state.data?.formTypeId]?.INCOMPATIBLE?.INSERT && <div className="pad-h-4">
                                <Button refer={this.ref.incompatibleProduct} theme={'red'} onClick={this.incompatibleProductClickHandler.bind(this)}>ثبت ناسازگاری</Button>
                            </div>}
                            {this.Perms[this.state.data?.formTypeId]?.CROSS_MATCH_OR_SENT?.CROSS_MATCH && <div className="pad-h-4">
                                <Button refer={this.ref.prepareProduct} theme={'blue'} onClick={this.prepareProductClickHandler.bind(this)}>آماده سازی</Button>
                            </div>}
                        </GroupHead>
                        <div className="dis-f">
                            <div className={'dis-f fb-6 fb-3x-10 fb-2x-20'}>
                                <InputButton ref={this.ref.productNumber} className={'pad-4 flex'} label={'شماره فرآورده'} value={state.fields?.productNumber} validation={this.validations.productNumber} onChange={this.setField.bind(this, 'productNumber')} onEnter={this.getProductInfo.bind(this)} buttonTitle={'جستجو'} onButtonClick={this.getProductInfo.bind(this)}/>
                                <button className={'product-list'}><img src={Resource.IMAGE.PACK.ALIGN_RIGHT} alt="" onClick={this.openProductListClickHandler.bind(this)}/></button>
                            </div>
                            <Input className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'نوع فرآورده'} value={state.data?.productInfo?.productTypeStr} readOnly={true}/>
                            <Input className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'تاریخ انقضا'} value={state.data?.productInfo?.productExpireDate} readOnly={true}/>
                            <Input className={'pad-4 fb-4 fb-3x-10 fb-2x-20'} label={'گروه خونی'} value={state.data?.productInfo?.productBloodGroupStr} readOnly={true} direction={"ltr"} align={'center'} style={bloodGroupInputStyle}/>
                            <div className="fb-10 fb-3x-20">
                                <Label>فاز‌های آزمایش سازگاری</Label>
                                <div className="dis-f">
                                    <Check className={'pad-4'} label={'دمای اتاق'} disabled={state?.data?.productInfo?.productEnzymeType != 1} checked={state?.fields?.roomTemperatureTest || false} onChange={this.setField.bind(this, 'roomTemperatureTest')}/>
                                    <Check className={'pad-4'} label={'آلبومین'} disabled={state?.data?.productInfo?.productEnzymeType != 1} checked={state?.fields?.albominTest || false} onChange={this.setField.bind(this, 'albominTest')}/>
                                    <Check className={'pad-4'} label={'آنتی هیومن'} disabled={state?.data?.productInfo?.productEnzymeType != 1} checked={state?.fields?.antiHumanTest || false} onChange={this.setField.bind(this, 'antiHumanTest')}/>
                                </div>
                            </div>
                            <div className="fb-10 fb-3x-20">
                                <div className="dis-f">
                                    <Time ref={this.ref.meltingStartDateTime} className={'pad-4 fb-10'} label={'شروع ذوب'} placeholder={'__:__'} disabled={state?.data?.productInfo?.productEnzymeType != 2} validation={this.validations.meltingStartDateTime} value={state.fields?.meltingStartDateTime} onChange={this.setField.bind(this, 'meltingStartDateTime')}/>
                                    <Time ref={this.ref.meltingEndDateTime} className={'pad-4 fb-10'} label={'پایان ذوب'} placeholder={'__:__'} disabled={state?.data?.productInfo?.productEnzymeType != 2} validation={this.validations.meltingEndDateTime} value={state.fields?.meltingEndDateTime} onChange={this.setField.bind(this, 'meltingEndDateTime')}/>
                                </div>
                            </div>
                        </div>
                    </Group>}
                    <Group className={'hemoPatientHistoryBloodRequest-group'} tabs={tabs}>
                        <GroupTabContent id={'prepared/delivered'}>
                            <Grid refer={this.ref.deliveryGrid} id={'hospitalDeliveryHistoryGrid'} {...this.state.deliveryGrid} rowData={this.state.data?.crossMatchList || []} onGridReady={this.deliveryGridReadyHandler.bind(this)} onSelectionChanged={this.deliveryGridSelectHandler.bind(this)}/>
                        </GroupTabContent>
                        <GroupTabContent id={'incompatible'}>
                            <Grid refer={this.ref.incompatibleGrid} id={'hospitalIncompatibleHistoryGrid'} {...this.state.incompatibleGrid} rowData={this.state.incompatibleList || []} onGridReady={this.incompatibleGridReadyHandler.bind(this)}/>
                        </GroupTabContent>
                    </Group>
                </ModalContent>
                <ModalControls>
                    {this.Perms[this.state.data?.formTypeId]?.CROSS_MATCH_OR_SENT?.DELIVERY && <Button refer={this.ref.send} className={'mar-4'} theme={'blue'} onClick={this.sendProductClickHandler.bind(this)}>ارسال {state.selectedRows.length || ''} فرآورده به {state.data?.patientFileCodeInformation?.patientLastName}</Button>}
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <Prompt ref={this.ref.prompt}/>
            <ModalHospitalDeliverProduct refer={this.ref.modalDeliver} onSuccess={this.modalSuccessHandler.bind(this)}/>
            <ModalPrepareAlert refer={this.ref.modalPrepareAlert} onSuccess={this.modalPrepareAlertSuccessHandler.bind(this)}/>
            <ModalProductList refer={this.ref.modalProductList}/>
            <ModalPrint refer={this.ref.modalPrint}/>
        </React.Fragment>;
    }

    autoPrintOnPrepareChangeHandler(value) {
        this.props.updateBase({hemoReadyProductPrintOnPrepare: value});
    }

    barcodeScanHandler(code) {
        const barcode = Tool.checkBarcode(code);
        if (barcode.type === 'PRODUCT_NUMBER') {
            this.setField('productNumber', barcode.data);
            this.getProductInfo();
        }
    }

    cancelCrossMatch(row, props = {loading: _ => null}) {
        this.ref.prompt.current.open({
            title: 'اخطار',
            description: 'آیا می خواهید فرآورده آماده شده را لغو کنید؟',
            size: 'small',
            buttons: PromptControl.YES_NO,
            onClose: button => {
                if (button.id === PromptControl.YES) {
                    props.loading();
                    Hospital.cancelCrossMatch({
                        crossMatchId: row?.crossMatchId
                    }).then(_ => {
                        this.getCrossMatchData();

                        this.setState({updated: true});

                        new Notif(Resource.STRING.FETCH.DELETE_SUCCESSFUL).show();
                        props.loading(false);
                    }).catch(message => {
                        new Notif({message, theme: 'error'}).show();
                        props.loading(false);
                    });
                }
            }
        });
    }

    cancelIncompatible(row, props = {loading: _ => null}) {
        this.ref.prompt.current.open({
            title: 'اخطار',
            description: 'آیا می خواهید ناسازگاری را حذف کنید؟',
            size: 'small',
            buttons: PromptControl.YES_NO,
            onClose: button => {
                if (button.id === PromptControl.YES) {
                    props.loading();
                    Hospital.cancelIncompatible({
                        incompatibleId: row?.incompatibleId
                    }).then(_ => {
                        this.getIncompatibleList();

                        this.setState({updated: true});

                        new Notif(Resource.STRING.FETCH.DELETE_SUCCESSFUL).show();
                        props.loading(false);
                    }).catch(message => {
                        new Notif({message, theme: 'error'}).show();
                        props.loading(false);
                    });
                }
            }
        });
    }

    close() {
        this.ref.modal.current.close();

        this.props.onClose();
    }

    crossMatch() {
        this.setState({error: null});
        this.ref.prepareProduct.current.loading(true);

        Hospital.crossMatch({
            sectionRequestId: this.state.data?.sectionRequestId,
            productId: this.state.data?.productInfo?.productId,
            plasmaDetail: this.state.data?.productInfo?.productEnzymeType == 2 ? {
                meltingStartDateTime: this.state?.fields?.meltingStartDateTime ? moment(this.state?.fields?.meltingStartDateTime, 'HH:mm').format() : null,
                meltingEndDateTime: this.state?.fields?.meltingEndDateTime ? moment(this.state?.fields?.meltingEndDateTime, 'HH:mm').format() : null
            } : null,
            bloodDetail: this.state.data?.productInfo?.productEnzymeType == 1 ? {
                roomTemperatureTest: this.state?.fields?.roomTemperatureTest || false,
                albominTest: this.state?.fields?.albominTest || false,
                antiHumanTest: this.state?.fields?.antiHumanTest || false
            } : null,
            securityInfo: this.state.alertResult?.username ? {
                username: this.state.alertResult?.username,
                password: this.state.alertResult?.password
            } : null
        })
            .then(_ => {
                this.setState({
                    error: null,
                    data: {
                        ...this.state.data,
                        productInfo: undefined
                    },
                    fields: {},
                    alertResult: undefined,
                    updated: true
                });

                this.ref.prepareProduct.current.loading(false);

                if (this.props.base?.hemoReadyProductPrintOnPrepare) {
                    this.printCrossMatch({createDateTime: moment().format()});
                }

                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();
                this.getCrossMatchData();
            })
            .catch(message => {
                this.ref.prepareProduct.current.loading(false);
                this.setState({error: message});
                new Notif({message, theme: 'error'}).show();
            });
    }

    deliveryGridReadyHandler(params) {
        this.setState({deliveryGridContext: params});
    }

    deliveryGridSelectHandler(rows) {
        this.setState({selectedRows: rows});
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'productNumber':
                const barcode = Tool.checkBarcode(value);
                if (barcode.type === "PRODUCT_NUMBER")
                    nextFields.productNumber = barcode.data;

                const data = {...this.state.data};
                delete data?.productInfo;
                this.setState({data});
                break;
            default:
        }
    }

    getCrossMatchData() {
        if (this.ref.deliveryGrid.current)
            this.ref.deliveryGrid.current.loading();

        this.setState({selectedRows: []});

        Hospital.crossMatchData({patientFileCodeId: this.state?.data?.patientFileCodeId})
            .then(data => {
                this.ref.deliveryGrid.current.loading(false);

                this.setState({
                    loading: null,
                    data: {
                        ...this.state.data,
                        ...data
                    }
                }, _ => {
                    this.getIncompatibleList();
                });
            })
            .catch(message => {
                this.ref.deliveryGrid.current.error();
                new Notif({message, theme: 'error'}).show();
                this.close();
            });
    }

    // this function needs to be called after getCrossMatchData()
    getIncompatibleList() {
        if (this.ref.incompatibleGrid.current)
            this.ref.incompatibleGrid.current.loading();

        Hospital.incompatibleList({fileCodeId: this.state?.data?.patientFileCodeId})
            .then(list => {
                this.ref.incompatibleGrid.current.loading(false);

                this.setState({incompatibleList: list}, _ => {
                    this.state.incompatibleGridContext.columnApi.autoSizeAllColumns();
                });
            })
            .catch(message => {
                this.ref.incompatibleGrid.current.error();
                new Notif({message, theme: 'error'}).show();
                this.close();
            });
    }

    getProductInfo() {
        const {fields} = this.state
        if (fields?.productNumber)
            this.ref.productNumber.current.error();
        else {
            this.ref.productNumber.current.error('شماره فرآورده وارد نشده است.');
            return;
        }

        this.setState({
            loading: 'در حال دریافت اطلاعات فرآورده',
            error: null
        });

        Product.data({productNumber: fields?.productNumber})
            .then(data => {
                if (data?.length > 1) {
                    this.setState({loading: null});

                    this.showProductList(fields?.productNumber);

                    return;
                }
                data = data[0];

                data.productExpireDate && (data.productExpireDate = moment(data.productExpireDate).format('jYYYY-jMM-jDD'));

                this.setState({
                    loading: null,
                    data: {
                        ...this.state.data,
                        productInfo: data
                    },
                    fields: {
                        ...(this.state?.fields || {}),
                        meltingStartDateTime: data.productEnzymeType == 2 ? moment().subtract(30, 'minute').format('HH:mm') : '',
                        meltingEndDateTime: data.productEnzymeType == 2 ? moment().format('HH:mm') : '',
                        roomTemperatureTest: data.productEnzymeType == 1 ? fields?.roomTemperatureTest : false,
                        albominTest: data.productEnzymeType == 1 ? fields?.albominTest : false,
                        antiHumanTest: data.productEnzymeType == 1 ? fields?.antiHumanTest : false
                    }
                }, _ => {
                    if (moment(this.state?.data?.productInfo?.productExpireDate, 'jYYYY-jMM-jDD').isBefore(moment(), 'jday'))
                        this.ref.productNumber.current.error('تاریخ انقضا فرآورده گذشته است.');
                    else
                        this.ref.productNumber.current.error(false);
                });
            })
            .catch(message => {
                this.setState({loading: null});
                new Notif({message, theme: 'error'}).show();
                this.ref.productNumber.current.error(message);
            });
    }

    incompatible() {
        this.setState({error: null});
        this.ref.incompatibleProduct.current.loading(true);

        Hospital.incompatible({
            productId: this.state.data?.productInfo?.productId,
            fileCodeId: this.state.data?.patientFileCodeId
        })
            .then(_ => {
                this.setState({
                    error: null,
                    data: {
                        ...this.state.data,
                        productInfo: undefined
                    },
                    fields: {},
                    updated: true
                });

                this.ref.incompatibleProduct.current.loading(false);

                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();
                this.getIncompatibleList();
            })
            .catch(message => {
                this.ref.incompatibleProduct.current.loading(false);
                this.setState({error: message});
                new Notif({message, theme: 'error'}).show();
            });
    }

    incompatibleGridReadyHandler(params) {
        this.setState({incompatibleGridContext: params});
    }

    incompatibleProductClickHandler() {
        const {state} = this;

        if (this.validateIncompatibleProduct()) {
            if (!state.data.productInfo) {
                this.getProductInfo();
                return;
            }

            this.incompatible();
        }
    }

    modalPrepareAlertSuccessHandler(data) {
        this.setState({alertResult: data}, _ => {
            this.crossMatch();
        });
    }

    modalSuccessHandler() {
        this.getCrossMatchData();

        this.setState({
            selectedRows: [],
            updated: true
        });
    }

    onModalClose() {
        if (this.state.updated)
            this.props.onSuccess();
    }

    open(data, action) {
        console.log(data);
        this.setState({
            data,
            action,
            error: null,
            loading: 'در حال دریافت اطلاعات',
            fields: {},
            incompatibleList: [],
            updated: false,
            selectedRows: []
        }, _ => {
            this.getCrossMatchData();
        });

        this.ref.modal.current.open();
    }

    openProductListClickHandler() {
        this.showProductList();
    }

    prepareProductClickHandler() {
        const {state} = this;

        if (this.validatePrepareProduct()) {
            if (!state.data.productInfo) {
                this.getProductInfo();
                return;
            }

            if (state.data?.patientFileCodeInformation?.patientBloodGroupId === state.data?.productInfo?.productBloodGroupId) {
                this.crossMatch();
            } else {
                this.ref.modalPrepareAlert.current.open({
                    patient: {
                        bloodGroupId: state.data?.patientFileCodeInformation?.patientBloodGroupId,
                        bloodGroupStr: state.data?.patientFileCodeInformation?.patientBloodGroupStr,
                        fileCode: state.data?.patientFileCodeInformation?.patientFileCode,
                        fullName: state.data?.patientFileCodeInformation?.patientFullName
                    },
                    product: {
                        bloodGroupId: state.data?.productInfo?.productBloodGroupId,
                        bloodGroupStr: state.data?.productInfo?.productBloodGroupStr,
                        enzymeType: state.data?.productInfo?.productEnzymeType,
                    }
                });
            }
        }
    }

    printCrossMatch(row) {
        this.ref.modalPrint.current.open({
            title: 'چاپ برچسب های فرآورده',
            prints: [{
                id: 'crossMatchLabel',
                // title: 'چاپ برچسب کراسمچ',
                count: 1,
                template: printerTemplate.CROSS_MATCH_LABEL,
                parameters: {
                    PFullName: this.state.data?.patientFullName,
                    PFileCodeStr: this.state.data?.patientFileCode,
                    PNationalCode: this.state.data?.patientNationalCode,
                    PBloodGroupStr: this.state.data?.patientBloodGroupStr,
                    CrossMatchDateTime: row.createDateTime ? moment(row.createDateTime).format('jYYYY/jMM/jDD HH:mm') : ''
                }
            }]
        });
    }

    sendProductClickHandler() {
        if (this.state.selectedRows.length > 0)
            this.ref.modalDeliver.current.open({
                ...this.state.data?.patientFileCodeInformation || {},
                crossMatchList: this.state.selectedRows || []
            });
        else
            new Notif({message: 'فرآورده‌ای انتخاب نشده است.', theme: 'error'}).show();
    }

    showProductList(productNumber) {
        this.ref.modalProductList.current.open({productNumber}, ModalAction.SELECT)
            .then(data => {
                let productExpireDate = data.productExpireDate;

                if (data.productExpireDate)
                    productExpireDate = moment(data.productExpireDate).format('jYYYY-jMM-jDD');

                this.setState({
                    data: {
                        ...this.state.data,
                        productInfo: {
                            cellTypeTest: data?.cellTypeTest,
                            productBloodGroupId: data?.productBloodGroupId,
                            productBloodGroupStr: data?.productBloodGroupStr,
                            // productEnzymeType: 1,
                            productExpireDate,
                            productId: data?.productId,
                            productNumber: data?.productNumber,
                            productTypeId: data?.productTypeId,
                            productTypeStr: data?.productTypeStr
                        }
                    },
                    fields: {
                        ...this.state.fields,
                        productNumber: data.productNumber
                    }
                }, _ => {
                    // this.getProductInfo();
                });
            });
    }

    validateIncompatibleProduct() {
        const validate = Tool.validate(this.ref.productNumber);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }

    validatePrepareProduct() {
        const validate = Tool.validate(this.ref.productNumber,
            this.ref.meltingStartDateTime,
            this.ref.meltingEndDateTime);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        gridDefaultSettings: state.grid.defaultSettings
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalHospitalReadyProduct);